import { getUpdateScrollbarHandler, setupDragHandler } from "../common/custom-scrollbar";

function initTextareaScrollbar(selector) {
  const containers = document.querySelectorAll(selector);

  containers.forEach((container) => {
    const textarea = container.querySelector(".original-textarea");
    const thumb = container.querySelector(".scrollbar-thumb");

    const updateScrollbar = getUpdateScrollbarHandler(textarea, thumb, null);

    textarea.addEventListener("input", updateScrollbar);
    textarea.addEventListener("scroll", updateScrollbar);

    setupDragHandler(textarea, thumb);

    container.addEventListener("wheel", (e) => {
      e.preventDefault();
      textarea.scrollTop += Math.sign(e.deltaY) * 20;
      updateScrollbar();
    }, { passive: false });

    updateScrollbar();
  });
}

export default initTextareaScrollbar;